<template>
    <div style="text-align:right">
      <span>
        {{ getValue() }}
      </span>
    </div>
  </template>
  <script>
  export default {
    props: ['row','nested_key','ex_field','decimalLength','decimalPlace'],
    
    methods: {
        getValue(){
            let nested = this.nested_key.split('.');
            if(this.row[nested[0]].hasOwnProperty(nested[1])){
                return this.row[nested[0]][nested[1]][this.ex_field]
            }
            
            return '';
        }
    },
  }
  </script>
  <style>
  .-td-color-comp {
    width: 50px;
    height: 20px;
    font-size: 12px;
    font-weight: bold;
    text-align: center;
    line-height: 20px;
  }
  </style>
  